import { render } from "./Datepicker.vue?vue&type=template&id=0ae4baca&lang=pug"
import script from "./Datepicker.vue?vue&type=script&setup=true&lang=js"
export * from "./Datepicker.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__